<div appBringozIdGenerator="openPricePopup"
     class="full-height layout-column"
     (click)="onOpenPriceDialog($event)">
  <div class="layout-row layout-align-start-center margin-bottom-5">
    <span>{{service.billingReference?.totalOrderChargeNoVat | bringozPrice}}</span>
  </div>
  <div *ngxPermissionsExcept="'contract.list'"
       layout="row" layout-align="start center">
    <span>{{service.billingReference?.courierPrice | bringozPrice}}</span>
  </div>
  <div *ngxPermissionsOnly="'contract.list'"
       layout="row" layout-align="start center">
    <span>{{service.supplyContractPrice?.totalCost | bringozPrice}}</span>
  </div>
</div>
